export { default } from './SummaryInfo';



// WEBPACK FOOTER //
// ./src/components/DataCentre/SummaryInfo/index.ts